import { DEFAULT_LOCALE } from '@/app/lib/localization/constants';

import { GameOrientation } from '@/shared/api/game/types';
import { type DecodedToken } from '@/shared/api/types';

import { type AppState, type StartAppArgs, ThemeMode } from './types';

export const DEFAULT_APP_STATE: Omit<AppState, 'actions'> = {
  token: '',
  userProfile: undefined,
  sessionId: '',
  decodedToken: {} as DecodedToken,
  gameUrl: null,
  game: null,
  isGameLoading: true,
  theme: ThemeMode.DARK,
  lang: { app: DEFAULT_LOCALE, game: DEFAULT_LOCALE },
  startAppArgs: {} as StartAppArgs,
  showDevMenu: false,
  wsSentInitialMsg: false,
  messages: {},
  isWebMode: false,
  isLiteMode: false,
  screenOrientation: GameOrientation.PORTRAIT,
  isExclusiveMode: false,
  pdTma: null,
};
